<template>
  <div class="dirbi-li" data-testid="dirbi-li-page">
    <DirbiCabecalho subtitulo="Lei de Informática · crédito financeiro por trimestre, a partir do Limite de Crédito do Sigplani">
      <v-btn
        class="elevation-4 mr-2"
        data-testid="dirbi-li-atualizar"
        @click="atualizar"
      >
        <v-icon left dark style="font-size: 20px">mdi-refresh</v-icon>
        <span style="font-size: 12px">Atualizar</span>
      </v-btn>
      <v-btn
        class="elevation-4"
        :class="{ 'dirbi-li-inativo': !podeExportar }"
        :color="backColor"
        dark
        data-testid="dirbi-li-exportar"
        @click="doExport"
      >
        <v-icon left style="font-size: 20px">mdi-file-pdf-box</v-icon>
        <span style="font-size: 12px">Exportação assíncrona</span>
      </v-btn>
    </DirbiCabecalho>

    <!-- Toolbar: filtros à esquerda, ação da tabela à direita -->
    <div class="toolbar d-flex align-center flex-wrap mt-3 mb-3 dirbi-li-toolbar">
      <servico-select
        class="dirbi-li-beneficio mr-6"
        data-testid="dirbi-beneficio"
      ></servico-select>

      <year-select
        v-model="anoBase"
        class="dirbi-li-ano mr-6"
        data-testid="dirbi-li-ano-base"
        @change="onPeriodoChange"
      ></year-select>

      <span class="dirbi-li-rotulo mr-3">Trimestres</span>
      <div class="dirbi-li-trimestres" data-testid="dirbi-li-trimestres">
        <v-checkbox
          v-for="t in [1, 2, 3, 4]"
          :key="t"
          v-model="trimestres"
          :value="t"
          :label="`${t}º tri`"
          class="mt-0 pt-0"
          :color="backColor"
          dense
          hide-details
          :data-testid="`dirbi-li-trimestre-${t}`"
          @change="onPeriodoChange"
        ></v-checkbox>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        class="elevation-4 dirbi-li-acao"
        :color="backColor"
        :style="{ '--dirbi-li-acao': backColor }"
        dark
        :disabled="!isLoading && !podePreencher"
        :loading="isLoading"
        data-testid="dirbi-li-preencher"
        @click="preencher"
      >
        <v-icon left style="font-size: 20px">mdi-tray-arrow-down</v-icon>
        <span style="font-size: 12px">Preencher valores</span>
      </v-btn>
    </div>

    <section class="dirbi-li-painel">
      <!-- DIRBI acumulada: só com mais de um trimestre marcado -->
      <div v-if="isMultiplo" class="dirbi-li-periodo">
        <div class="dirbi-li-acumulada" data-testid="dirbi-li-acumulada">
          <span>Mais de um trimestre marcado: esta é uma <strong>DIRBI acumulada</strong>?</span>
          <v-radio-group
            v-model="acumulada"
            row
            hide-details
            dense
            class="mt-0 pt-0"
            data-testid="dirbi-li-acumulada-opcao"
          >
            <v-radio label="Sim" :value="true" color="#7a5600" data-testid="dirbi-li-acumulada-sim"></v-radio>
            <v-radio label="Não" :value="false" color="#7a5600" data-testid="dirbi-li-acumulada-nao"></v-radio>
          </v-radio-group>
          <template v-if="acumulada">
            <span>Trimestre de referência no PDF:</span>
            <select
              v-model.number="trimestreReferencia"
              class="dirbi-li-referencia"
              data-testid="dirbi-li-trimestre-referencia"
            >
              <option v-for="op in opcoesReferencia" :key="op.value" :value="op.value">{{ op.text }}</option>
            </select>
          </template>
        </div>
      </div>

      <table class="dirbi-li-tabela" data-testid="dirbi-li-tabela">
        <thead>
          <tr>
            <th class="text-right" style="width: 80px">Nº</th>
            <th>Nome Incentivo</th>
            <th class="text-right">Valor do crédito financeiro</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-right dirbi-li-link">173</td>
            <td class="dirbi-li-link">BENS DE INFORMÁTICA</td>
            <td class="text-right dirbi-li-valor" data-testid="dirbi-li-valor">
              <template v-if="valorPreenchido !== null">
                {{ valorPreenchido | toCurrency }}
                <span class="dirbi-li-fonte">Limite de Crédito · Sigplani</span>
              </template>
              <em v-else class="dirbi-li-vazio">{{ textoValorVazio }}</em>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="mensagem"
        class="dirbi-li-msg"
        :class="`dirbi-li-msg--${mensagem.type}`"
        data-testid="dirbi-li-mensagem"
      >
        <v-icon small class="mr-2">{{ iconeMensagem }}</v-icon>
        <span v-html="mensagem.text"></span>
      </div>

      <details
        v-if="dirbi && trimestres.length"
        class="dirbi-li-detalhe"
        open
        data-testid="dirbi-li-composicao"
      >
        <summary>
          <span>
            <v-icon small class="dirbi-li-seta">mdi-chevron-right</v-icon>
            Composição do valor — Limite de Crédito da tela Crédito Financeiro — Sigplani
          </span>
          <span v-if="dirbi.regiao" class="dirbi-li-regiao">Região do cliente: {{ dirbi.regiao }}</span>
        </summary>
        <table>
          <thead>
            <tr>
              <th>Competência</th>
              <th class="text-right">Limite PPB</th>
              <th class="text-right">Limite TecNac</th>
              <th class="text-right">Limite de Crédito</th>
              <th>Status do cálculo</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="tri in dirbi.trimestres">
              <tr
                v-for="comp in tri.competencias"
                :key="comp.competencia"
                :data-testid="`dirbi-li-competencia-${comp.competencia}`"
              >
                <td>{{ comp.competencia | toMonth }}</td>
                <template v-if="temValor(comp)">
                  <td class="text-right">{{ comp.limite_ppb | toCurrency }}</td>
                  <td class="text-right">{{ comp.limite_tecnac | toCurrency }}</td>
                  <td class="text-right dirbi-li-forte">{{ comp.limite_credito | toCurrency }}</td>
                </template>
                <template v-else>
                  <td class="text-right dirbi-li-vazio">—</td>
                  <td class="text-right dirbi-li-vazio">—</td>
                  <td class="text-right dirbi-li-vazio">—</td>
                </template>
                <td>
                  <span class="dirbi-li-chip" :class="`dirbi-li-chip--${comp.status}`">
                    {{ comp.status_label }}
                  </span>
                </td>
              </tr>
              <tr :key="`sub-${tri.trimestre}`" class="dirbi-li-subtotal">
                <td>
                  Subtotal {{ tri.trimestre }}º trimestre
                  <span v-if="!tri.competencias.every(temValor)" class="dirbi-li-parcial">(parcial)</span>
                </td>
                <td class="text-right">{{ tri.limite_ppb | toCurrency }}</td>
                <td class="text-right">{{ tri.limite_tecnac | toCurrency }}</td>
                <td class="text-right">{{ tri.limite_credito | toCurrency }}</td>
                <td></td>
              </tr>
            </template>
            <tr v-if="dirbi.trimestres.length > 1" class="dirbi-li-total">
              <td>Total do período</td>
              <td></td>
              <td></td>
              <td class="text-right">{{ totalComposicao | toCurrency }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </details>
    </section>

    <!-- Prévia do PDF entregável (mesmo layout de pdf/dirbi/lei_informatica.blade.php) -->
    <section class="dirbi-li-painel mt-4" data-testid="dirbi-li-previa">
      <div class="dirbi-pdf-topo">
        <h2>Prévia do PDF entregável</h2>
        <span>Modelo conforme a DIRBI oficial (benefícios declarados)</span>
      </div>
      <div class="dirbi-pdf-palco">
        <div class="dirbi-pdf-folha">
          <div class="dirbi-pdf-cabecalho">
            <div
              v-if="logoCliente"
              class="dirbi-pdf-logo"
              :style="{ backgroundImage: `url('${logoCliente}')` }"
            ></div>
            <div v-else class="dirbi-pdf-logo dirbi-pdf-logo--vazio">{{ nomeFantasia }}</div>
            <div class="dirbi-pdf-titulo-folha" data-testid="dirbi-li-previa-titulo">
              <b>{{ razaoSocial }}</b> | Incentivo Lei de Informática | DIRBI | {{ periodoPdf }}
            </div>
          </div>

          <div class="dirbi-pdf-cap">BENEFÍCIOS DECLARADOS</div>
          <div class="dirbi-pdf-bloco">
            <div class="dirbi-pdf-topo-bloco">
              <div class="dirbi-pdf-info">
                <div class="dirbi-pdf-nome">Benefício: BENS DE INFORMÁTICA E COMUNICAÇÃO - Crédito Financeiro</div>
                <b>Descrição:</b> Crédito financeiro decorrente de dispêndio mínimo efetivamente aplicado nas
                atividades de desenvolvimento ou produção de bens de tecnologias da informação e comunicação,
                realizado por pessoas jurídicas que investirem anualmente, no país, em atividades de pesquisa,
                desenvolvimento e inovação nesse setor, no mínimo 5% (cinco por cento) da base de cálculo formada
                pelo faturamento bruto no mercado interno, decorrente da comercialização de bens de tecnologias da
                informação e comunicação, e que cumprirem o processo produtivo básico, definido pelo Poder
                Executivo.<br />
                <b>Dispositivos Normativos:</b> Lei nº 8.248, de 1991, arts. 4º, 9º, 11, 16-A; Lei nº 13.969, de
                2019, arts. 2º a 10; Decreto nº 10.356, de 2020.
              </div>
              <div class="dirbi-pdf-valor" data-testid="dirbi-li-previa-valor">
                Valor Usufruído: {{ valorPdf }}
              </div>
            </div>
            <div class="dirbi-pdf-linha dirbi-pdf-linha--cabecalho"><span>Tributo</span><span>Valor</span></div>
            <div class="dirbi-pdf-linha"><span>Crédito Financeiro</span><span>{{ valorPdf }}</span></div>
          </div>

          <div class="dirbi-pdf-rodape">
            <img :src="logoGalapos" alt="Galapos" />
            <span>Confidencial</span>
          </div>
        </div>
      </div>
    </section>

    <QueueDialog
      appendIcon="mdi-file-pdf-box"
      title="Exportação assíncrona - DIRBI Lei de Informática"
      :opened.sync="isVisibleQueueDialog"
    ></QueueDialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QueueDialog from "@/components/queue-dialog.vue";
import DirbiCabecalho from "./cabecalho.vue";
import DirbiLeiInformaticaService from "@/services/dirbi-lei-informatica.service";
import logoGalapos from "@/img/logoGalaposPdf.png";

const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

const listaOrdinais = trimestres =>
  trimestres.map(t => `${t}º`).join(", ").replace(/, ([^,]*)$/, " e $1");

export default {
  components: {
    DirbiCabecalho,
    QueueDialog,
    "year-select": () => import("@/components/year-select.vue"),
    "servico-select": () => import("@/components/servico-select.vue")
  },
  filters: {
    toMonth(competencia) {
      const [ano, mes] = `${competencia}`.split("-");
      return `${MESES[Number(mes) - 1]}/${ano}`;
    }
  },
  data() {
    const trimestreStore = [].concat(this.$store.getters.trimestre || [])
      .map(Number)
      .filter(t => t >= 1 && t <= 4);

    return {
      service: new DirbiLeiInformaticaService(),
      logoGalapos,
      anoBase: this.$store.getters.anoBase,
      trimestres: trimestreStore.length ? [trimestreStore[0]] : [1],
      acumulada: true,
      trimestreReferencia: null,
      dirbi: null,
      preenchido: false,
      isLoading: false,
      isVisibleQueueDialog: false,
      requisicaoAtual: 0
    };
  },
  computed: {
    ...mapGetters(["clientId", "selectedClient"]),
    trimestresOrdenados() {
      return [...this.trimestres].map(Number).sort((a, b) => a - b);
    },
    isMultiplo() {
      return this.trimestres.length > 1;
    },
    opcoesReferencia() {
      return this.trimestresOrdenados.map(t => ({ text: `${t}º trimestre`, value: t }));
    },
    completo() {
      return !!this.dirbi?.completo;
    },
    // Durante o carregamento o botão fica em `loading` (que já bloqueia o clique), e não
    // `disabled`: com os dois juntos o Vuetify pinta o fundo de cinza-claro e o spinner
    // branco desaparece.
    podePreencher() {
      return !!this.trimestres.length && this.completo;
    },
    podeExportar() {
      return this.preenchido && this.completo;
    },
    valorPreenchido() {
      return this.preenchido && this.completo ? this.dirbi.total : null;
    },
    totalComposicao() {
      return (this.dirbi?.trimestres || []).reduce((sum, t) => sum + (t.limite_credito || 0), 0);
    },
    textoValorVazio() {
      if (this.dirbi && !this.completo) {
        return "Cálculo pendente";
      }

      return "Não preenchido";
    },
    razaoSocial() {
      return this.selectedClient?.razao_social || this.selectedClient?.fantasia || "Empresa";
    },
    nomeFantasia() {
      return this.selectedClient?.fantasia || this.razaoSocial;
    },
    logoCliente() {
      return this.selectedClient?.logo || null;
    },
    /** Mesma regra de DirbiLeiInformaticaService::rotuloPeriodo (RN05) */
    periodoPdf() {
      const trimestres = this.trimestresOrdenados;

      if (!trimestres.length) {
        return "—";
      }

      if (trimestres.length === 1) {
        return `${trimestres[0]}º Trimestre do Ano de ${this.anoBase}`;
      }

      if (this.acumulada && this.trimestreReferencia) {
        return `${this.trimestreReferencia}º Trimestre do Ano de ${this.anoBase}`;
      }

      return `${listaOrdinais(trimestres)} Trimestres do Ano de ${this.anoBase}`;
    },
    valorPdf() {
      return this.valorPreenchido !== null ? this.$options.filters.toCurrency(this.valorPreenchido) : "—";
    },
    iconeMensagem() {
      return {
        info: "mdi-information-outline",
        warning: "mdi-alert-outline",
        success: "mdi-check"
      }[this.mensagem?.type];
    },
    mensagem() {
      if (!this.trimestres.length) {
        return { type: "info", text: "Marque ao menos um trimestre do ano-base." };
      }

      if (!this.dirbi) {
        return null;
      }

      if (!this.completo) {
        const pendencias = (this.dirbi.pendencias || [])
          .map(({ competencia, status }) => `${this.$options.filters.toMonth(competencia)} (${status.toLowerCase()})`)
          .join(", ");
        const fila = this.dirbi.calculo_na_fila
          ? "Há um cálculo de crédito financeiro na fila para o período. "
          : "";

        return {
          type: "warning",
          text: `${fila}${pendencias ? `${pendencias}. ` : ""}O valor só pode ser preenchido quando todas as competências do período estiverem calculadas.`
        };
      }

      if (!this.preenchido) {
        return {
          type: "info",
          text: "Clique em <strong>Preencher valores</strong> para buscar o Limite de Crédito das competências selecionadas."
        };
      }

      if (this.isMultiplo && !this.acumulada) {
        return {
          type: "info",
          text: `Trimestres marcados sem acumular: a tela mostra o total, e o PDF sai com o período "${listaOrdinais(this.trimestresOrdenados)} Trimestres".`
        };
      }

      const competencias = this.trimestres.length * 3;
      return {
        type: "success",
        text: `Valor preenchido com o Limite de Crédito da tela Crédito Financeiro — Sigplani (${competencias} competências${this.isMultiplo ? ", DIRBI acumulada" : ""}).`
      };
    }
  },
  watch: {
    clientId() {
      this.onPeriodoChange();
    },
    trimestresOrdenados(trimestres) {
      // A carta acumulada é entregue no último trimestre do período (RN05): a referência
      // volta para ele a cada mudança de seleção; o consultor pode trocar em seguida.
      this.trimestreReferencia = trimestres[trimestres.length - 1] || null;
    }
  },
  created() {
    this.trimestreReferencia = this.trimestresOrdenados[this.trimestresOrdenados.length - 1] || null;
    this.carregar();
  },
  methods: {
    temValor({ status }) {
      return ["calculado", "fechado"].includes(status);
    },
    onPeriodoChange() {
      this.preenchido = false;
      this.carregar();
    },
    atualizar() {
      this.onPeriodoChange();
    },
    async carregar() {
      this.dirbi = null;

      if (!this.clientId || !this.anoBase || !this.trimestres.length) {
        return;
      }

      // Evita que uma resposta antiga sobrescreva a seleção mais recente
      const requisicao = ++this.requisicaoAtual;
      this.isLoading = true;

      try {
        const { data } = await this.service.getDirbi(this.clientId, {
          anoBase: this.anoBase,
          trimestres: this.trimestresOrdenados
        });

        if (requisicao === this.requisicaoAtual) {
          this.dirbi = data;
        }
      } catch (error) {
        this.notify(error);
      } finally {
        if (requisicao === this.requisicaoAtual) {
          this.isLoading = false;
        }
      }
    },
    async preencher() {
      await this.carregar();

      if (!this.completo) {
        return;
      }

      this.preenchido = true;
      this.$notify({
        group: "geral",
        type: "success",
        title: "DIRBI Lei de Informática",
        text: "Valores preenchidos a partir do Limite de Crédito (Sigplani)."
      });
    },
    async doExport() {
      if (!this.podeExportar) {
        this.$notify({
          group: "geral",
          type: "warning",
          title: "DIRBI Lei de Informática",
          text: "Preencha o valor do período antes de exportar."
        });
        return;
      }

      try {
        await this.service.exportar(this.clientId, {
          anoBase: this.anoBase,
          trimestres: this.trimestresOrdenados,
          acumulada: this.isMultiplo && this.acumulada,
          trimestreReferencia: this.isMultiplo && this.acumulada ? this.trimestreReferencia : null
        });
        this.isVisibleQueueDialog = true;
      } catch (error) {
        this.notify(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// Paleta do protótipo da US 4605 (Teros-LI-DIRBI-Prototipo.html). Os botões usam `backColor`
// e o fundo do cabeçalho das tabelas `--v-table-header-base`, que mudam conforme a visão
// (consultor azul, cliente verde).
$tinta: #12294a;
$texto: #1d2433;
$suave: #667085;
$linha: #dfe6ef;
$link: #1f4f95;
$aviso-bg: #fdf1cf;
$aviso-fg: #7a5600;
$ok-bg: #dff3e9;
$ok-fg: #1c6b4c;
$info-bg: #e8f1fc;
$espera-bg: #eceef2;
$espera-fg: #5b6475;

.dirbi-li {
  color: $texto;
}

.dirbi-li-painel {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
}

.dirbi-li-toolbar {
  gap: 8px 0;
}

.dirbi-li-beneficio {
  max-width: 265px;
}

.dirbi-li-ano {
  max-width: 130px;
}

.dirbi-li-inativo {
  opacity: 0.55;
}

// Desabilitado: o Vuetify pinta o fundo de `rgba(255,255,255,.12)` e o texto de
// `rgba(255,255,255,.3)` (regra `.theme--dark.v-btn.v-btn--disabled:not(...)` com !important)
// — o botão some. Mantém a cor da visão com opacidade reduzida, como no protótipo. O seletor
// repete as classes da regra do Vuetify para ganhar na especificidade.
.v-btn.dirbi-li-acao.theme--dark.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: var(--dirbi-li-acao) !important;
  color: #fff !important;
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto;

  ::v-deep .v-icon,
  ::v-deep .v-btn__content {
    color: #fff !important;
  }
}

.dirbi-li-periodo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 10px 14px;
  border-bottom: 1px solid $linha;
  background: #f7fafe;
}

.dirbi-li-rotulo {
  font-size: 11.5px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: $suave;
}

.dirbi-li-trimestres {
  display: inline-flex;
  align-items: center;
  gap: 4px 16px;
  padding: 4px 12px;
  border: 1px solid #b9cde6;
  border-radius: 6px;
  background: #fff;

  ::v-deep .v-label {
    font-size: 12.5px;
    color: $texto;
  }
}

.dirbi-li-acumulada {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  padding: 6px 10px;
  border-radius: 6px;
  background: $aviso-bg;
  color: $aviso-fg;
  font-size: 12.5px;

  ::v-deep .v-label {
    font-size: 12.5px;
    color: $aviso-fg;
  }
}

.dirbi-li-referencia {
  padding: 2px 6px;
  border: 1px solid #e3cf8f;
  border-radius: 4px;
  background: #fff;
  color: $texto;
  font-size: 12.5px;
  appearance: auto;
}

.dirbi-li-tabela,
.dirbi-li-detalhe table {
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;

  th {
    padding: 10px 14px;
    background: var(--v-table-header-base);
    color: $tinta;
    font-size: 11.5px;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
  }

  td {
    padding: 12px 14px;
    border-bottom: 1px solid $linha;
    font-size: 12.5px;
  }

  .text-right {
    text-align: right;
  }
}

.dirbi-li-link {
  color: $link;
}

.dirbi-li-valor {
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
}

.dirbi-li-fonte {
  display: block;
  margin-top: 2px;
  font-size: 10.5px;
  font-weight: 400;
  color: $suave;
}

.dirbi-li-vazio {
  color: $suave;
  font-size: 12px;
  font-weight: 400;
}

.dirbi-li-msg {
  display: flex;
  align-items: flex-start;
  margin: 12px 14px 14px;
  padding: 9px 12px;
  border-radius: 6px;
  font-size: 12.5px;

  .v-icon {
    color: inherit;
    margin-top: 1px;
  }

  &--warning {
    background: $aviso-bg;
    color: $aviso-fg;
  }

  &--success {
    background: $ok-bg;
    color: $ok-fg;
  }

  &--info {
    background: $info-bg;
    color: $tinta;
  }
}

.dirbi-li-detalhe {
  summary {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 11px 14px;
    border-top: 1px solid $linha;
    cursor: pointer;
    list-style: none;
    font-size: 12.5px;
    font-weight: 600;
    color: $tinta;

    &::-webkit-details-marker {
      display: none;
    }
  }

  .dirbi-li-seta {
    color: $tinta;
    transition: transform 0.15s;
  }

  &[open] .dirbi-li-seta {
    transform: rotate(90deg);
  }

  .dirbi-li-regiao {
    font-weight: 400;
    color: $suave;
  }

  th {
    background: #eaf3fd;
  }

  td {
    padding: 8px 14px;
    font-size: 12px;
  }
}

.dirbi-li-forte {
  font-weight: 500;
}

.dirbi-li-subtotal td {
  background: #f3f7fc;
  font-weight: 600;
}

.dirbi-li-total td {
  background: var(--v-table-header-base);
  font-weight: 700;
}

.dirbi-li-parcial {
  font-weight: 400;
  color: $suave;
}

.dirbi-li-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  background: $espera-bg;
  color: $espera-fg;

  &--fechado {
    background: $ok-bg;
    color: $ok-fg;
  }

  &--calculado {
    background: #e3eefb;
    color: $tinta;
  }

  &--em_andamento {
    background: $aviso-bg;
    color: $aviso-fg;
  }
}

/* Prévia do PDF — proporção do papel do DirbiLeiInformaticaExport (2560 x 1440, paisagem) */
.dirbi-pdf-topo {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid $linha;

  h2 {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: $tinta;
  }

  span {
    font-size: 11.5px;
    color: $suave;
  }
}

.dirbi-pdf-palco {
  padding: 22px;
  overflow-x: auto;
  background: #5b6270;
}

.dirbi-pdf-folha {
  display: flex;
  flex-direction: column;
  width: 880px;
  min-height: 495px;
  margin: 0 auto;
  padding: 26px 30px 18px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  font-size: 12px;
}

.dirbi-pdf-cabecalho {
  display: flex;
  align-items: center;
  gap: 22px;
}

.dirbi-pdf-logo {
  flex: 0 0 90px;
  height: 52px;
  background: center / contain no-repeat;

  &--vazio {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid #2f4fbf;
    border-radius: 4px;
    background: none;
    color: #2f4fbf;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-align: center;
    text-transform: uppercase;
  }
}

.dirbi-pdf-titulo-folha {
  font-size: 14px;
  color: #333;

  b {
    color: #222;
  }
}

.dirbi-pdf-cap {
  margin-top: 20px;
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #c2410c;
}

.dirbi-pdf-bloco {
  margin-top: 6px;
  border: 1px solid #9fb9d9;
  font-size: 10.5px;
  color: #333;
}

.dirbi-pdf-topo-bloco {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 210px;
  background: #e8f1fb;
}

.dirbi-pdf-info {
  padding: 8px 10px;
  border-right: 1px solid #9fb9d9;
  line-height: 1.45;

  b {
    font-weight: 500;
    color: $link;
  }
}

.dirbi-pdf-nome {
  font-size: 11px;
  font-weight: 600;
  color: $link;
}

.dirbi-pdf-valor {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  color: $link;
  text-align: right;
}

.dirbi-pdf-linha {
  display: grid;
  grid-template-columns: 1fr 210px;
  padding: 4px 10px;
  border-top: 1px solid #9fb9d9;

  span:last-child {
    text-align: right;
  }

  &--cabecalho {
    background: #dbe8f7;
    font-weight: 600;
    color: $link;
  }
}

.dirbi-pdf-rodape {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: auto;
  font-size: 11px;
  color: #333;

  img {
    height: 20px;
  }
}
</style>
